import {
    UPDATE_BREADCRUMBS_STATE
} from '../constants/breadcrumbsConstant';

/**
 * Reducer function for managing breadcrumbs state.
 *
 * @param {object} state - Current state of the breadcrumbs.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const breadcrumbsReducer = (
    state = {
        breadcrumbs : [
            // { content: 'Home', link: '#', isCurrent: false },
            // { content: 'Dashboard', link: '/dashboard', isCurrent: true }
        ]
    }, 
    action
) => {
	switch (action.type) {
		case UPDATE_BREADCRUMBS_STATE:
			return { 
                ...state,
                breadcrumbs: action.payload
            };
		default:
			return state;
	}
};
